import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HeadingWidgetService {
  constructor() {}

  camelToUnderscore(key): string {
    if (!!key) {
      key = key.replace("Component", "");
      const convertedToSnake = key
        .replace(/\.?([A-Z])/g, (x, y): string => "_" + y.toLowerCase())
        .replace(/^_/, "");
      return convertedToSnake;
    }
  }
}
